import React, { useState } from "react";
import { Box, Tabs, Tab, Paper, Grid } from "@mui/material";

import CreatedRaffle from "../../components/RaffleManagement/CreatedRaffles";
import PurchasedRaffle from "../../components/RaffleManagement/PurchasedRaffles";

function RaffleManagementMain() {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid p={1.5}>
      <Paper
        elevation={1}
        sx={{
          height: { md: "90vh", sm: "90%", xs: "90%" },
          overflow: "hidden",
          maxWidth: "100%",
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ maxWidth: "100%", p: 2 }}
        >
          <Tab label="Created Raffles" />
          <Tab label="Purchased Raffles" />
        </Tabs>
        {value === 0 && (
          <Box sx={{ mt: 1, p: 1 }}>
            <CreatedRaffle />
          </Box>
        )}
        {value === 1 && (
          <Box sx={{ mt: 1, p: 1 }}>
            <PurchasedRaffle />
          </Box>
        )}
      </Paper>
    </Grid>
  );
}

export default RaffleManagementMain;
